import { render, staticRenderFns } from "./InvitationPassword.vue?vue&type=template&id=1ec998d4&scoped=true&"
import script from "./InvitationPassword.vue?vue&type=script&lang=js&"
export * from "./InvitationPassword.vue?vue&type=script&lang=js&"
import style0 from "./InvitationPassword.vue?vue&type=style&index=0&id=1ec998d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec998d4",
  null
  
)

export default component.exports